import React, { ReactNode } from 'react';
import { Card, CardHeader, CardProps, Collapse } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { RotatingIconButton } from './RotatingIconButton';
import { PaddedCardContent } from './PaddedCardContent';

type ExpandableContainerProps = CardProps & {
  header?: ReactNode;
  children?: ReactNode;
  defaultExpanded?: boolean;
  padded?: boolean;
};

export const ExpandableContainer = ({
  header,
  children,
  defaultExpanded = false,
  padded = true,
  ...props
}: ExpandableContainerProps) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const toggleExpanded = React.useCallback(() => {
    setExpanded(expanded => !expanded);
  }, []);

  return (
    <Card {...props}>
      <CardHeader
        title={header}
        style={{ backgroundColor: '#f0f3f5', cursor: 'pointer' }}
        onClick={toggleExpanded}
        action={
          <RotatingIconButton rotated={expanded}>
            <ExpandMore />
          </RotatingIconButton>
        }
      />
      <Collapse in={expanded} timeout="auto">
        <PaddedCardContent padded={padded}>{children}</PaddedCardContent>
      </Collapse>
    </Card>
  );
};
